export default {
  name: 'validationHelper',
  methods: {
    buildCustomMessage(field, message) {
      return { custom: { [field]: message } };
    },
    parseRules(rules) {
      const returnObj = {};

      if (Object.prototype.hasOwnProperty.call(rules, 'required')) {
        returnObj.required = rules.required === 'true';
      }
      if (Object.prototype.hasOwnProperty.call(rules, 'min')) {
        returnObj.min = parseInt(rules.min, 10);
      }
      if (Object.prototype.hasOwnProperty.call(rules, 'max')) {
        returnObj.max = parseInt(rules.max, 10);
      }
      if (Object.prototype.hasOwnProperty.call(rules, 'regex')) {
        returnObj.regex = new RegExp(rules.regex.replace(/\\/g, ''));
      }
      return returnObj;
    },
    validateAllFields() {
      // New Elements
      if (window.ApexEventBus) {
        window.ApexEventBus.dispatchEvent('apexValidate');
      }

      const fields = document.querySelectorAll('input:not([type="radio"]), select, textarea');
      let res = true;

      Array.prototype.forEach.call(fields, (field) => {
        field.dispatchEvent(new Event('change'));
      });

      const toggleFields = document.querySelectorAll('apx-toggle');
      Array.prototype.forEach.call(toggleFields, (toggleField) => {
        const togField = toggleField;
        if (togField && togField.value === '') {
          togField.valid = false;
          res = false;
        }
      });

      const apexElements = ['apx-options-list'];
      apexElements.forEach((apx) => {
        const element = document.querySelector(apx);
        if (element && !element.valid && element.required) {
          res = false;
        }
      });

      const buttonFocus = document.querySelector('button');
      if (buttonFocus) {
        buttonFocus.focus();
      }
      return res;
    },
    buildRules(type) {
      const fullNameRules = {
        firstName: this.pd_validationRules.customerIdentity.firstName,
        lastName: this.pd_validationRules.customerIdentity.lastName,
        middleName: this.pd_validationRules.customerIdentity.middleName,
      };

      const ssnRules = { validations: {} };
      ssnRules.validations.min = 11;
      ssnRules.validations.max = 11;
      ssnRules.validations.regex = '^(?!000-00-0000|111-11-1111|333-33-3333|123-45-6789)[0-9]{3}-[0-9]{2}-[0-9]{4}$';
      ssnRules.validations.required = this.pd_validationRules.customerIdentity.taxReportingId.required;

      const phoneRules = {
        telephoneNumber: this.pd_validationRules.customerContact.telephoneNumber,
      };

      const emailRules = { validations: this.pd_validationRules.customerContact.primaryEmail };

      // PIPBP-5062 - disallow comma in city name
      this.pd_validationRules.address.cityName.regex = "^([a-zA-Z0-9`\\-'\\s\\.]+)?$";
      const addressRules = {
        addressLine1: this.pd_validationRules.address.addressLine1,
        addressLine2: this.pd_validationRules.address.addressLine2,
        addressLine3: {
          required: false, max: 100, min: 100, regex: '',
        },
        cityName: this.pd_validationRules.address.cityName,
        stateCode: this.pd_validationRules.address.stateCode,
        zipCode: this.pd_validationRules.address.zipCode,
        zipCode2: {
          required: false, max: 100, min: 100, regex: '',
        },
      };

      const affiliationRules = {
        autocomplete: this.pd_validationRules.affiliation.affiliatedCompanyName,
      };

      const controlPersonRules = {
        autocomplete: this.pd_validationRules.controlPerson.tradingSymbol,
      };

      const companyNameRules = {
        employerName: this.pd_validationRules.employment.employerName,
      };

      const occupationRules = {
        occupation: this.pd_validationRules.employment.occupation,
      };

      return {
        ...(type === 'address' && addressRules),
        ...(type === 'affiliation' && affiliationRules),
        ...(type === 'controlPerson' && controlPersonRules),
        ...(type === 'email' && emailRules),
        ...(type === 'fullName' && fullNameRules),
        ...(type === 'phone' && phoneRules),
        ...(type === 'ssn' && ssnRules),
        ...(type === 'companyName' && companyNameRules),
        ...(type === 'occupation' && occupationRules),
      };
    },
    buildTrustSSNRules() {
      const ssnRules = { validations: {} };
      ssnRules.validations.min = 11;
      ssnRules.validations.max = 11;
      ssnRules.validations.regex = '^(?!000-00-0000|111-11-1111|333-33-3333|123-45-6789)[0-9]{3}-[0-9]{2}-[0-9]{4}$';
      ssnRules.validations.required = true;
      return JSON.stringify(ssnRules);
    },
    buildTrustTINRules() {
      const tinRules = { validations: {} };
      tinRules.validations.min = 9;
      tinRules.validations.max = 9;
      tinRules.validations.regex = '^(?!000000000|111111111|333333333|123456789|043523567)[0-9]{9}$';
      tinRules.validations.required = true;
      return JSON.stringify(tinRules);
    },
  },
};
